import React from "react";
import Footer from "../partials/footer/Footer";
import Nav from "../partials/nav/Nav";
import { Route, Switch } from "react-router-dom";
import routes from "../../route/routes";

function Dashboard() {
  return (
    <>
      <Nav />
      <Switch>
        {routes.map((route) => (
          <Route render={route.render} path={route.path} exact={route.exact} />
        ))}
      </Switch>
      <Footer />
    </>
  );
}

export default Dashboard;
